import { apiClient } from './api';

export interface SaleItem {
  id: string;
  serviceId?: string | null;
  service?: { id: string; name: string } | null;
  productId?: string | null;
  product?: { id: string; name: string; unit: string } | null;
  name: string;
  quantity: number;
  unitPrice: number;
  total: number;
}

export interface Sale {
  id: string;
  salonId: string;
  clientId?: string | null;
  client?: { id: string; firstName: string; lastName: string } | null;
  staffId: string;
  staff: { id: string; firstName: string; lastName: string };
  paymentMethod: string;
  status: string;
  totalAmount: number;
  notes?: string | null;
  createdAt: string;
  items: SaleItem[];
}

export interface SalesSummary {
  totalRevenue: number;
  totalCount: number;
  todayRevenue: number;
  todayCount: number;
  methodBreakdown: Record<string, { amount: number; count: number }>;
}

export interface CreateSaleInput {
  salonId: string;
  staffId: string;
  clientId: string;
  paymentMethod: string;
  notes?: string;
  items: {
    // Pozycja wskazuje usluge ALBO produkt — nigdy oba naraz.
    serviceId?: string | null;
    productId?: string | null;
    name: string;
    quantity: number;
    unitPrice: number;
  }[];
}

export const salesApi = {
  async create(data: CreateSaleInput) {
    const res = await apiClient.post<Sale>('/sales', data);
    return res.data;
  },

  async list(params: {
    salonId: string;
    dateFrom?: string;
    dateTo?: string;
    staffId?: string;
    status?: string;
    page?: number;
    limit?: number;
  }) {
    const res = await apiClient.get<{ data: Sale[]; pagination: { page: number; limit: number; total: number; totalPages: number } }>('/sales', { params });
    return res.data;
  },

  async getById(id: string) {
    const res = await apiClient.get<Sale>(`/sales/${id}`);
    return res.data;
  },

  async refund(id: string) {
    const res = await apiClient.patch<Sale>(`/sales/${id}/refund`);
    return res.data;
  },

  async getSummary(params: { salonId: string; dateFrom?: string; dateTo?: string }) {
    const res = await apiClient.get<SalesSummary>('/sales/summary', { params });
    return res.data;
  },
};
